export const REGISTER_RENTAL_OPERATOR_START = "REGISTER_RENTAL_OPERATOR_START";
export const REGISTER_RENTAL_OPERATOR_SUCCESS =
  "REGISTER_RENTAL_OPERATOR_SUCCESS";
export const REGISTER_RENTAL_OPERATOR_ERROR = "REGISTER_RENTAL_OPERATOR_ERROR";
export const COMMON_FORM_STEPPER_SUCCESS = "COMMON_FORM_STEPPER_SUCCESS";
export const VERIFY_OTP_OPERATOR_START = "VERIFY_OTP_OPERATOR_START";
export const VERIFY_OTP_OPERATOR_SUCCESS = "VERIFY_OTP_OPERATOR_SUCCESS";
export const VERIFY_OTP_OPERATOR_ERROR = "VERIFY_OTP_OPERATOR_ERROR";
export const FAQ_OPERATOR_START = "FAQ_OPERATOR_START";
export const FAQ_OPERATOR_SUCCESS = "FAQ_OPERATOR_SUCCESS";
export const FAQ_OPERATOR_ERROR = "FAQ_OPERATOR_ERROR";
export const FAQ_CUSTOMER_START = "FAQ_CUSTOMER_START";
export const FAQ_CUSTOMER_SUCCESS = "FAQ_CUSTOMER_SUCCESS";
export const FAQ_CUSTOMER_ERROR = "FAQ_CUSTOMER_ERROR";
export const TOUR_CUSTOMER_LOCATION_SUCCESS = "TOUR_CUSTOMER_LOCATION_SUCCESS";
export const BOOKING_DETAIL_SUCCESS = "BOOKING_DETAIL_SUCCESS";
export const BOOKING_DETAIL_START = "BOOKING_DETAIL_START";
export const BOOKING_DETAIL_ERROR = "BOOKING_DETAIL_ERROR";
export const UPDATE_BOOKING_DETAIL_SUCCESS = "UPDATE_BOOKING_DETAIL_SUCCESS";
export const UPDATE_BOOKING_DETAIL_ERROR = "UPDATE_BOOKING_DETAIL_ERROR";
export const ADD_REVIEW_DETAIL_SUCCESS = "ADD_REVIEW_DETAIL_SUCCESS";
export const ADD_REVIEW_DETAIL_ERROR = "ADD_REVIEW_DETAIL_ERROR";
export const DOWNLOAD_FILE_REQUEST = "DOWNLOAD_FILE_REQUEST";
export const DOWNLOAD_FILE_SUCCESS = "DOWNLOAD_FILE_SUCCESS";
export const CLEAR_PREVIOUS_DATA = "CLEAR_PREVIOUS_DATA";
export const VERIFY_MAIL_OTP_OPERATOR_START = "VERIFY_MAIL_OTP_OPERATOR_START";
export const VERIFY_MAIL_OTP_OPERATOR_SUCCESS =
  "VERIFY_MAIL_OTP_OPERATOR_SUCCESS";
export const VERIFY_MAIL_OTP_OPERATOR_ERROR = "VERIFY_MAIL_OTP_OPERATOR_ERROR";
export const VERIFIED_OTP_OPERATOR_SUCCESS = "VERIFIED_OTP_OPERATOR_SUCCESS";
export const VERIFIED_OTP_OPERATOR_START = "VERIFIED_OTP_OPERATOR_START";
export const VERIFIED_OTP_OPERATOR_ERROR = "VERIFIED_OTP_OPERATOR_ERROR";
export const VERIFIED_PARTNER_OTP_OPERATOR_SUCCESS =
  "VERIFIED_PARTNER_OTP_OPERATOR_SUCCESS";
export const GET_UPDATE_SUBSTITUE_BIKES = "GET_UPDATE_SUBSTITUE_BIKES";
export const GET_UPDATE_SUBSTITUE_BIKES_SUCCESS =
  "GET_UPDATE_SUBSTITUE_BIKES_SUCCESS";
export const GET_UPDATE_SUBSTITUE_BIKES_ERROR =
  "GET_UPDATE_SUBSTITUE_BIKES_ERROR";
export const VERIFIED_PARTNER_OTP_OPERATOR_START =
  "VERIFIED_PARTNER_OTP_OPERATOR_START";
export const VERIFIED_PARTNER_OTP_OPERATOR_ERROR =
  "VERIFIED_PARTNER_OTP_OPERATOR_ERROR";
export const VERIFIED_MAIL_OTP_OPERATOR_START =
  "VERIFIED_MAIL_OTP_OPERATOR_START";
export const VERIFIED_MAIL_OTP_OPERATOR_SUCCESS =
  "VERIFIED_MAIL_OTP_OPERATOR_SUCCESS";
export const VERIFIED_MAIL_OTP_OPERATOR_ERROR =
  "VERIFIED_MAIL_OTP_OPERATOR_ERROR";
export const RENTAL_PARTNER_DETAIL_START = "RENTAL_PARTNER_DETAIL_START";
export const RENTAL_PARTNER_DETAIL_SUCCESS = "RENTAL_PARTNER_DETAIL_SUCCESS";
export const RENTAL_PARTNER_DETAIL_ERROR = "RENTAL_PARTNER_DETAIL_ERROR";
export const SHOW_ALL_REVIEW_START = "SHOW_ALL_REVIEW_START";
export const SHOW_ALL_REVIEW_SUCCESS = "SHOW_ALL_REVIEW_SUCCESS";
export const SHOW_ALL_REVIEW_ERROR = "SHOW_ALL_REVIEW_ERROR";

export const CANCEL_BOOKING_DETAIL_START = "CANCEL_BOOKING_DETAIL_START";
export const CANCEL_BOOKING_DETAIL_SUCCESS = "CANCEL_BOOKING_DETAIL_SUCCESS";
export const CANCEL_BOOKING_DETAIL_ERROR = "CANCEL_BOOKING_DETAIL_ERROR";

export const CANCEL_BOOKING_SAVE_SUCCESS = "CANCEL_BOOKING_SAVE_SUCCESS";
export const CANCEL_BOOKING_SAVE_ERROR = "CANCEL_BOOKING_SAVE_ERROR";

export const CANCEL_BOOKING_GET_DETAIL_START = "CANCEL_BOOKING_DETAIL_START";
export const CANCEL_BOOKING_GET_DETAIL_SUCCESS =
  "CANCEL_BOOKING_DETAIL_SUCCESS";
export const CANCEL_BOOKING_GET_DETAIL_ERROR = "CANCEL_BOOKING_DETAIL_ERROR";

export const UPDATE_ALTERNATIVE_BOOKING_START =
  "UPDATE_ALTERNATIVE_BOOKING_START";
export const UPDATE_ALTERNATIVE_BOKING_SUCCESS =
  "UPDATE_ALTERNATIVE_BOKING_SUCCESS";
export const UPDATE_ALTERNATIVE_BOKINGL_ERROR =
  "UPDATE_ALTERNATIVE_BOKINGL_ERROR";
export const CANCEL_ALTERNATIVE_BOKINGL_START =
  "CANCEL_ALTERNATIVE_BOKINGL_START";
export const CANCEL_ALTERNATIVE_BOKINGL_SUCCESS =
  "CANCEL_ALTERNATIVE_BOKINGL_SUCCESS";
export const CANCEL_ALTERNATIVE_BOKING_ERROR =
  "CANCEL_ALTERNATIVE_BOKING_ERROR";

export const CANCEL_BOOKING_POLICY_START = "CANCEL_BOOKING_POLICY_START";
export const CANCEL_BOOKING_POLICY_SUCCESS = "CANCEL_BOOKING_POLICY_SUCCESS";
export const CANCEL_BOOKING_POLICY_ERROR = "CANCEL_BOOKING_POLICY_ERROR";
export const AVERAGE_ALL_RATE_SUCCESS = "AVERAGE_ALL_RATE_SUCCESS";

export const ALTERNATIVE_BIKE_SUCCESS = "ALTERNATIVE_BIKE_SUCCESS";
export const ALTERNATIVE_BIKE_ERROR = "ALTERNATIVE_BIKE_ERROR";
export const ALTERNATIVE_BIKE_START = "ALTERNATIVE_BIKE_START";

export const OPERATOR_PRE_ONBOARDING_SUCCESS =
  "OPERATOR_PRE_ONBOARDING_SUCCESS";
export const OPERATOR_PRE_ONBOARDING_ERROR = "OPERATOR_PRE_ONBOARDING_ERROR";
export const OPERATOR_PRE_ONBOARDING_START = "OPERATOR_PRE_ONBOARDING_START";

export const OPERATOR_GET_PRE_ONBOARDING_DATA_SUCCESS =
  "OPERATOR_GET_PRE_ONBOARDING_DATA_SUCCESS";
export const OPERATOR_GET_PRE_ONBOARDING_DATA_ERROR =
  "OPERATOR_GET_PRE_ONBOARDING_DATA_ERROR";
export const OPERATOR_GET_PRE_ONBOARDING_DATA_START =
  "OPERATOR_GET_PRE_ONBOARDING_DATA_START";

export const AEM_API_SUCCESS = "AEM_API_SUCCESS";
export const AEM_API_ERROR = "AEM_API_ERROR";
export const AEM_API_START = "AEM_API_START";
export const OPERATOR_PRE_ONBOARDING_SEND_BACK_REVIEW_SUCCESS =
  "OPERATOR_PRE_ONBOARDING_SEND_BACK_REVIEW_SUCCESS";
export const OPERATOR_PRE_ONBOARDING_SEND_BACK_REVIEW_ERROR =
  "OPERATOR_PRE_ONBOARDING_SEND_BACK_REVIEW_ERROR";
export const OPERATOR_PRE_ONBOARDING_SEND_BACK_REVIEW_START =
  "OPERATOR_PRE_ONBOARDING_SEND_BACK_REVIEW_START";

export const OPERATOR_FIRST_TIME_GET_ONBOARDING_DATA_SUCCESS =
  "OPERATOR_FIRST_TIME_GET_ONBOARDING_DATA_SUCCESS";
export const OPERATOR_FIRST_TIME_GET_ONBOARDING_DATA_ERROR =
  "OPERATOR_FIRST_TIME_GET_ONBOARDING_DATA_ERROR";
export const OPERATOR_FIRST_TIME_GET_ONBOARDING_DATA_START =
  "OPERATOR_FIRST_TIME_GET_ONBOARDING_DATA_START";

export const OPERATOR_ONBOARDING_ACCOUNT_SETUP_DATA_SUCCESS =
  "OPERATOR_ONBOARDING_ACCOUNT_SETUP_DATA_SUCCESS";
export const OPERATOR_ONBOARDING_ACCOUNT_SETUP_DATA_ERROR =
  "OPERATOR_ONBOARDING_ACCOUNT_SETUP_DATA_ERROR";
export const OPERATOR_ONBOARDING_ACCOUNT_SETUP_DATA_START =
  "OPERATOR_ONBOARDING_ACCOUNT_SETUP_DATA_START";

export const OPERATOR_ONBOARDING_BUSSINESS_INFO_SUCCESS =
  "OPERATOR_ONBOARDING_BUSSINESS_INFO_SUCCESS";
export const OPERATOR_ONBOARDING_BUSSINESS_INFO_ERROR =
  "OPERATOR_ONBOARDING_BUSSINESS_INFO_ERROR";
export const OPERATOR_ONBOARDING_BUSSINESS_INFO_START =
  "OPERATOR_ONBOARDING_BUSSINESS_INFO_START";

export const TEARM_AND_CANCEL_POLICY_SUCCESS =
  "TEARM_AND_CANCEL_POLICY_SUCCESS";
export const TEARM_AND_CANCEL_POLICY_ERROR = "TEARM_AND_CANCEL_POLICY_ERROR";
export const RENTAL_ADMIN_FIRST_TIME_APPROVAL_DETAIL_SUCCESS =
  "RENTAL_ADMIN_FIRST_TIME_APPROVAL_DETAIL_SUCCESS";
export const RENTAL_ADMIN_FIRST_TIME_APPROVAL_DETAIL_ERROR =
  "RENTAL_ADMIN_FIRST_TIME_APPROVAL_DETAIL_ERROR";
export const RENTAL_ADMIN_FIRST_TIME_APPROVAL_DETAIL_START =
  "RENTAL_ADMIN_FIRST_TIME_APPROVAL_DETAIL_START";

export const SAVE_FOR_LATER_SUCCESS = "SAVE_FOR_LATER_SUCCESS";
export const SAVE_FOR_LATER_ERROR = "SAVE_FOR_LATER_ERROR";
export const SAVE_FOR_LATER = "SAVE_FOR_LATER";

export const OPERATOR_ONBOARDING_BANK_ACCOUNT_TAX_SUCCESS =
  "OPERATOR_ONBOARDING_BANK_ACCOUNT_TAX_SUCCESS";
export const OPERATOR_ONBOARDING_BANK_ACCOUNT_TAX_ERROR =
  "OPERATOR_ONBOARDING_BANK_ACCOUNT_TAX_ERROR";
export const OPERATOR_ONBOARDING_BANK_ACCOUNT_TAX_START =
  "OPERATOR_ONBOARDING_BANK_ACCOUNT_TAX_START";

export const GET_REGISTARATION_DETAILS_FROM_CHASIS_SUCCESS =
  "GET_REGISTARATION_DETAILS_FROM_CHASIS_SUCCESS";
export const GET_REGISTARATION_DETAILS_FROM_CHASIS_ERROR =
  "GET_REGISTARATION_DETAILS_FROM_CHASIS_ERROR";
export const GET_REGISTARATION_DETAILS_FROM_CHASIS_START =
  "GET_REGISTARATION_DETAILS_FROM_CHASIS_START";

export const OPERATOR_BULK_TOURS_UPLOAD_SUCCESS =
  "OPERATOR_BULK_TOURS_UPLOAD_SUCCESS";
export const OPERATOR_BULK_TOURS_UPLOAD_ERROR =
  "OPERATOR_BULK_TOURS_UPLOAD_ERROR";
export const OPERATOR_BULK_TOURS_UPLOAD_START =
  "OPERATOR_BULK_TOURS_UPLOAD_START";

export const OPERATOR_BULK_VAS_UPLOAD_SUCCESS =
  "OPERATOR_BULK_VAS_UPLOAD_SUCCESS";
export const OPERATOR_BULK_VAS_UPLOAD_ERROR = "OPERATOR_BULK_VAS_UPLOAD_ERROR";
export const OPERATOR_BULK_VAS_UPLOAD_START = "OPERATOR_BULK_VAS_UPLOAD_START";

export const GET_TOURS_SUCCESS = "GET_TOURS_SUCCESS";
export const GET_TOURS_ERROR = "GET_TOURS_ERROR";
export const GET_TOURS_START = "GET_TOURS_START";

export const ADD_TOURS_SUCCESS = "ADD_TOURS_SUCCESS";
export const ADD_TOURS_ERROR = "ADD_TOURS_ERROR";
export const ADD_TOURS_START = "ADD_TOURS_START";

export const EDIT_TOURS_SUCCESS = "EDIT_TOURS_SUCCESS";
export const EDIT_TOURS_ERROR = "EDIT_TOURS_ERROR";
export const EDIT_TOURS_START = "EDIT_TOURS_START";

export const DELETE_TOURS_SUCCESS = "DELETE_TOURS_SUCCESS";
export const DELETE_TOURS_ERROR = "DELETE_TOURS_ERROR";
export const DELETE_TOURS_START = "DELETE_TOURS_START";

export const ADD_VAS_SUCCESS = "ADD_VAS_SUCCESS";
export const ADD_VAS_ERROR = "ADD_VAS_ERROR";
export const ADD_VAS_START = "ADD_VAS_START";

export const EDIT_VAS_SUCCESS = "EDIT_VAS_SUCCESS";
export const EDIT_VAS_ERROR = "EDIT_VAS_ERROR";
export const EDIT_VAS_START = "EDIT_VAS_START";

export const GET_VAS_SUCCESS = "GET_VAS_SUCCESS";
export const GET_VAS_ERROR = "GET_VAS_ERROR";
export const GET_VAS_START = "GET_VAS_START";

export const DELETE_VAS_SUCCESS = "DELETE_VAS_SUCCESS";
export const DELETE_VAS_ERROR = "DELETE_VAS_ERROR";
export const DELETE_VAS_START = "DELETE_VAS_START";

export const ADD_MOTORCYCLE_SUCCESS = "ADD_MOTORCYCLE_SUCCESS";
export const ADD_MOTORCYCLE_ERROR = "ADD_MOTORCYCLE_ERROR";
export const ADD_MOTORCYCLE_START = "ADD_MOTORCYCLE_START";

export const GET_MOTORCYCLE_SUCCESS = "GET_MOTORCYCLE_SUCCESS";
export const GET_MOTORCYCLE_ERROR = "GET_MOTORCYCLE_ERROR";
export const GET_MOTORCYCLE_START = "GET_MOTORCYCLE_START";

export const DELETE_MOTORCYCLE_SUCCESS = "DELETE_MOTORCYCLE_SUCCESS";
export const DELETE_MOTORCYCLE_ERROR = "DELETE_MOTORCYCLE_ERROR";
export const DELETE_MOTORCYCLE_START = "DELETE_MOTORCYCLE_START";

export const GET_MOTORCYCLE_LOCATION_SUCCESS =
  "GET_MOTORCYCLE_LOCATION_SUCCESS";
export const GET_MOTORCYCLE_LOCATION_ERROR = "GET_MOTORCYCLE_LOCATION_ERROR";
export const GET_MOTORCYCLE_LOCATION_START = "GET_MOTORCYCLE_LOCATION_START";

export const UPLOAD_BULK_MOTORCYCLE_SUCCESS = "UPLOAD_BULK_MOTORCYCLE_SUCCESS";
export const UPLOAD_BULK_MOTORCYCLE_ERROR = "UPLOAD_BULK_MOTORCYCLE_ERROR";
export const UPLOAD_BULK_MOTORCYCLE_START = "UPLOAD_BULK_MOTORCYCLE_START";

export const GET_MOTORCYCLE_BY_ID_SUCCESS = "GET_MOTORCYCLE_BY_ID_SUCCESS";
export const GET_MOTORCYCLE_BY_ID_ERROR = "GET_MOTORCYCLE_BY_ID_ERROR";
export const GET_MOTORCYCLE_BY_ID_START = "GET_MOTORCYCLE_BY_ID_START";

export const EDIT_MOTORCYCLE_SUCCESS = "EDIT_MOTORCYCLE_SUCCESS";
export const EDIT_MOTORCYCLE_ERROR = "EDIT_MOTORCYCLE_ERROR";
export const EDIT_MOTORCYCLE_START = "EDIT_MOTORCYCLE_START";

export const MOTORCYCLE_LIST_FILTER_START = "MOTORCYCLE_LIST_FILTER_START";
export const MOTORCYCLE_LIST_FILTER_ERROR = "MOTORCYCLE_LIST_FILTER_ERROR";
export const MOTORCYCLE_LIST_FILTER_SUCCESS = "MOTORCYCLE_LIST_FILTER_SUCCESS";

export const BULK_UPLOAD_MOTORCYCLE_LIST_START =
  "BULK_UPLOAD_MOTORCYCLE_LIST_START";
export const BULK_UPLOAD_MOTORCYCLE_LIST_ERROR =
  "BULK_UPLOAD_MOTORCYCLE_LIST_ERROR";
export const BULK_UPLOAD_MOTORCYCLE_LIST_SUCCESS =
  "BULK_UPLOAD_MOTORCYCLE_LIST_SUCCESS";

export const MULTI_MOTORCYCLE_MARK_AS_AVAILABLE_START =
  "MULTI_MOTORCYCLE_MARK_AS_AVAILABLE_START";
export const MULTI_MOTORCYCLE_MARK_AS_AVAILABLE_ERROR =
  "MULTI_MOTORCYCLE_MARK_AS_AVAILABLE_ERROR";
export const MULTI_MOTORCYCLE_MARK_AS_AVAILABLE_SUCCESS =
  "MULTI_MOTORCYCLE_MARK_AS_AVAILABLE_SUCCESS";

export const MULTI_MOTORCYCLE_DELETE_START = "MULTI_MOTORCYCLE_DELETE_START";
export const MULTI_MOTORCYCLE_DELETE_ERROR = "MULTI_MOTORCYCLE_DELETE_ERROR";
export const MULTI_MOTORCYCLE_DELETE_SUCCESS =
  "MULTI_MOTORCYCLE_DELETE_SUCCESS";

export const RENTAL_ADMIN_NEWREGISTRATION_DETAIL_SUCCESS =
  "RENTAL_ADMIN_NEWREGISTRATION_DETAIL_SUCCESS";
export const RENTAL_ADMIN_NEWREGISTRATION_DETAIL_ERROR =
  "RENTAL_ADMIN_NEWREGISTRATION_DETAIL_ERROR";
export const RENTAL_ADMIN_NEWREGISTRATION_DETAIL_START =
  "RENTAL_ADMIN_NEWREGISTRATION_DETAIL_START";

export const AEM_RENTAL_LISTING_CF_SUCCESS = "AEM_RENTAL_LISTING_CF_SUCCESS";
export const AEM_RENTAL_LISTING_CF_ERROR = "AEM_RENTAL_LISTING_CF_ERROR";
export const AEM_RENTAL_LISTING_CF_START = "AEM_RENTAL_LISTING_CF_START";
//Azure file upload
export const AZURE_UPLOAD_SUCCESS = "AZURE_UPLOAD_SUCCESS";
export const AZURE_UPLOAD_ERROR = "AZURE_UPLOAD_ERROR";
export const AZURE_UPLOAD_START = "AZURE_UPLOAD_START";

export const ECHECK_MOBILE_AVILABLE_SUCCESS = "ECHECK_MOBILE_AVILABLE_SUCCESS";
export const ECHECK_MOBILE_AVILABLE_ERROR = "ECHECK_MOBILE_AVILABLE_ERROR";

export const ECHECK_EMAIL_AVILABLE_SUCCESS = "ECHECK_EMAIL_AVILABLE_SUCCESS";
export const ECHECK_EMAIL_AVILABLE_ERROR = "ECHECK_EMAIL_AVILABLE_ERROR";

// State Country & City
export const COUNTRY_LISTING_CF_SUCCESS = "COUNTRY_LISTING_CF_SUCCESS";
export const COUNTRY_LISTING_CF_ERROR = "COUNTRY_LISTING_CF_ERROR";
export const COUNTRY_LISTING_CF_START = "COUNTRY_LISTING_CF_START";

export const STATE_LISTING_CF_SUCCESS = "STATE_LISTING_CF_SUCCESS";
export const STATE_LISTING_CF_ERROR = "STATE_LISTING_CF_ERROR";
export const STATE_LISTING_CF_START = "STATE_LISTING_CF_START";

export const CITY_LISTING_CF_SUCCESS = "CITY_LISTING_CF_SUCCESS";
export const CITY_LISTING_CF_ERROR = "CITY_LISTING_CF_ERROR";
export const CITY_LISTING_CF_START = "CITY_LISTING_CF_START";
export const OPERATOR_LOGIN_SUCCESS = "OPERATOR_LOGIN_SUCCESS";
export const OPERATOR_LOGIN_ERROR = "OPERATOR_LOGIN_ERROR";
export const OPERATOR_LOGIN_START = "OPERATOR_LOGIN_START";

//ContractVerification
export const GET_OPERATOR_CONTRACT_DETAIL_START =
  "GET_OPERATOR_CONTRACT_DETAIL_START";
export const GET_OPERATOR_CONTRACT_DETAIL_ERROR =
  "GET_OPERATOR_CONTRACT_DETAIL_ERROR";
export const GET_OPERATOR_CONTRACT_DETAIL_SUCCESS =
  "GET_OPERATOR_CONTRACT_DETAIL_SUCCESS";
export const DOWNLOAD_CONTARCT_DETAIL_SUCCESS =
  "DOWNLOAD_CONTARCT_DETAIL_SUCCESS";
export const DOWNLOAD_CONTARCT_DETAIL_ERROR = "DOWNLOAD_CONTARCT_DETAIL_ERROR";
export const UPLOAD_CONTARCT_DETAIL_SUCCESS = "UPLOAD_CONTARCT_DETAIL_SUCCESS";
export const UPLOAD_CONTARCT_DETAIL_ERROR = "UPLOAD_CONTARCT_DETAIL_ERROR";

export const GET_PORDUCT_REVIEW_RATING_DETAIL_START =
  "GET_PORDUCT_REVIEW_RATING_DETAIL_START";
export const GET_PORDUCT_REVIEW_RATING_DETAIL_SUCCESS =
  "GET_PORDUCT_REVIEW_RATING_DETAIL_SUCCESS";
export const GET_PORDUCT_REVIEW_RATING_DETAIL_ERROR =
  "GET_PORDUCT_REVIEW_RATING_DETAIL_ERROR";

export const GET_OPERATOR_REVIEW_RATING_DETAIL_START =
  "GET_OPERATOR_REVIEW_RATING_DETAIL_START";
export const GET_OPERATOR_REVIEW_RATING_DETAIL_SUCCESS =
  "GET_OPERATOR_REVIEW_RATING_DETAIL_SUCCESS";
export const GET_OPERATOR_REVIEW_RATING_DETAIL_ERROR =
  "GET_OPERATOR_REVIEW_RATING_DETAIL_ERROR";

export const QUICK_EDIT_MOTORCYCLE_START = "QUICK_EDIT_MOTORCYCLE_START";
export const QUICK_EDIT_MOTORCYCLE_SUCCESS = "QUICK_EDIT_MOTORCYCLE_SUCCESS";
export const QUICK_EDIT_MOTORCYCLE_ERROR = "QUICK_EDIT_MOTORCYCLE_ERROR";
//MANAGE VAS PAGE
export const VAS_LIST_START = "VAS_LIST_START";
export const VAS_LIST_SUCCESS = "VAS_LIST_SUCCESS";
export const VAS_LIST_ERROR = "VAS_LIST_ERROR";

//operator transaction
export const ALL_TRANSACTION_LIST_START = "ALL_TRANSACTION_LIST_START";
export const ALL_TRANSACTION_LIST_SUCCESS = "ALL_TRANSACTION_LIST_SUCCESS";
export const ALL_TRANSACTION_LIST_ERROR = "ALL_TRANSACTION_LIST_ERROR";
export const PENDING_TRANSACTION_LIST_START = "PENDING_TRANSACTION_LIST_START";
export const PENDING_TRANSACTION_LIST_SUCCESS =
  "PENDING_TRANSACTION_LIST_SUCCESS";
export const PENDING_TRANSACTION_LIST_ERROR = "PENDING_TRANSACTION_LIST_ERROR";
export const COMPLETED_TRANSACTION_LIST_START =
  "COMPLETED_TRANSACTION_LIST_START";
export const COMPLETED_TRANSACTION_LIST_SUCCESS =
  "COMPLETED_TRANSACTION_LIST_SUCCESS";
export const COMPLETED_TRANSACTION_LIST_ERROR =
  "COMPLETED_TRANSACTION_LIST_ERROR";

///AcountInfo

export const GET_ACCOUNT_INFO_DETAIL_START = "GET_ACCOUNT_INFO_DETAIL_START";
export const GET_ACCOUNT_INFO_DETAIL_ERROR = "GET_ACCOUNT_INFO_DETAIL_ERROR";
export const GET_ACCOUNT_INFO_DETAIL_SUCCESS =
  "GET_ACCOUNT_INFO_DETAIL_SUCCESS";

// Operator Bookings
export const OPERATOR_BOOKING_LIST_START = "OPERATOR_BOOKING_LIST_START";
export const OPERATOR_BOOKING_UPCOMING_LIST = "OPERATOR_BOOKING_UPCOMING_LIST";
export const OPERATOR_BOOKING_ONGOING_LIST = "OPERATOR_BOOKING_ONGOING_LIST";
export const OPERATOR_BOOKING_COMPLETED_LIST =
  "OPERATOR_BOOKING_COMPLETED_LIST";
export const OPERATOR_BOOKING_CANCELLED_LIST =
  "OPERATOR_BOOKING_CANCELLED_LIST";
export const OPERATOR_BOOKING_LIST_ERROR = "OPERATOR_BOOKING_LIST_ERROR";
export const OPERATOR_BOOKING_START_TRIP_START =
  "OPERATOR_BOOKING_START_TRIP_START";
export const OPERATOR_BOOKING_START_TRIP_SUCCESS =
  "OPERATOR_BOOKING_START_TRIP_SUCCESS";
export const OPERATOR_BOOKING_START_TRIP_ERROR =
  "OPERATOR_BOOKING_START_TRIP_ERROR";
export const OPERATOR_BOOKING_DETAIL_START = "OPERATOR_BOOKING_DETAIL_START";
export const OPERATOR_BOOKING_DETAIL_SUCCESS =
  "OPERATOR_BOOKING_DETAIL_SUCCESS";
export const OPERATOR_BOOKING_DETAIL_ERROR = "OPERATOR_BOOKING_DETAIL_ERROR";

export const PENDING_PAYMENTS_LIST_START = "PENDING_PAYMENTS_LIST_START";
export const PENDING_PAYMENTS_LIST_SUCCESS = "PENDING_PAYMENTS_LIST_SUCCESS";
export const PENDING_PAYMENTS_LIST_ERROR = "PENDING_PAYMENTS_LIST_ERROR";
export const COMPLETED_PAYMENTS_LIST_START = "COMPLETED_PAYMENTS_LIST_START";
export const COMPLETED_PAYMENTS_LIST_SUCCESS =
  "COMPLETED_PAYMENTS_LIST_SUCCESS";
export const COMPLETED_PAYMENTS_LIST_ERROR = "COMPLETED_PAYMENTS_LIST_ERROR";

//Admin operator live list
export const LIVE_OPERATOR_LIST_START = "LIVE_OPERATOR_LIST_START";
export const LIVE_OPERATOR_LIST_SUCCESS = "LIVE_OPERATOR_LIST_SUCCESS";
export const LIVE_OPERATOR_LIST_ERROR = "LIVE_OPERATOR_LIST_ERROR";

export const PENDING_VERIFICATION_MOTORCYCLE_START =
  "PENDING_VERIFICATION_MOTORCYCLE_START";
export const PENDING_VERIFICATION_MOTORCYCLE_SUCCESS =
  "PENDING_VERIFICATION_MOTORCYCLE_SUCCESS";
export const PENDING_VERIFICATION_MOTORCYCLE_ERROR =
  "PENDING_VERIFICATION_MOTORCYCLE_ERROR";
export const GET_PROFILE_OPERATOR_DETAIL_START =
  "GET_PROFILE_OPERATOR_DETAIL_START";
export const GET_PROFILE_OPERATOR_DETAIL_ERROR =
  "GET_PROFILE_OPERATOR_DETAIL_ERROR";
export const GET_PROFILE_OPERATOR_DETAIL_SUCCESS =
  "GET_PROFILE_OPERATOR_DETAIL_SUCCESS";
export const GET_PROFILE_OPERATOR_CLEAR_REDUCER =
  "GET_PROFILE_OPERATOR_CLEAR_REDUCER";

//Rider Document
export const UPLOAD_RIDER_DOC_START = "UPLOAD_RIDER_DOC_START";
export const UPLOAD_RIDER_DOC_SUCCESS = "UPLOAD_RIDER_DOC_SUCCESS";
export const UPLOAD_RIDER_DOC_ERROR = "UPLOAD_RIDER_DOC_ERROR";
export const OPERATOR_BOOKING_END_TRIP_START =
  "OPERATOR_BOOKING_END_TRIP_START";
export const OPERATOR_BOOKING_END_TRIP_SUCCESS =
  "OPERATOR_BOOKING_END_TRIP_SUCCESS";
export const OPERATOR_BOOKING_END_TRIP_ERROR =
  "OPERATOR_BOOKING_END_TRIP_ERROR";

//Update Approval Admin
export const RENTAL_ADMIN_UPDATE_APPROVAL_DETAIL_SUCCESS =
  "RENTAL_ADMIN_UPDATE_APPROVAL_DETAIL_SUCCESS";
export const RENTAL_ADMIN_UPDATE_APPROVAL_DETAIL_ERROR =
  "RENTAL_ADMIN_UPDATE_APPROVAL_DETAIL_ERROR";
export const RENTAL_ADMIN_UPDATE_APPROVAL_DETAIL_START =
  "RENTAL_ADMIN_UPDATE_APPROVAL_DETAIL_START";

export const STATE_LIST_SUCCESS = "STATE_LIST_SUCCESS";
export const STATE_LIST_ERROR = "STATE_LIST_ERROR";
// Operator Terms and condtion
export const OPERATOR_TERMS_AND_POLICIES_START =
  "OPERATOR_TERMS_AND_POLICIES_START";
export const OPERATOR_TERMS_AND_POLICIES_SUCCESS =
  "OPERATOR_TERMS_AND_POLICIES_SUCCESS";
export const OPERATOR_TERMS_AND_POLICIES_ERROR =
  "OPERATOR_TERMS_AND_POLICIES_ERROR";
export const OPERATOR_TERMS_AND_POLICIES_SAVE_START =
  "OPERATOR_TERMS_AND_POLICIES_SAVE_START";
export const OPERATOR_TERMS_AND_POLICIES_SAVE_SUCCESS =
  "OPERATOR_TERMS_AND_POLICIES_SAVE_SUCCESS";
export const OPERATOR_TERMS_AND_POLICIES_SAVE_ERROR =
  "OPERATOR_TERMS_AND_POLICIES_SAVE_ERROR";
export const OPERATOR_LOCATION_START = "OPERATOR_LOCATION_START";
export const OPERATOR_LOCATION_SUCCESS = "OPERATOR_LOCATION_SUCCESS";
export const OPERATOR_LOCATION_ERROR = "OPERATOR_LOCATION_ERROR";
export const OPERATOR_MODEL_START = "OPERATOR_MODEL_START";
export const OPERATOR_MODEL_SUCCESS = "OPERATOR_MODEL_SUCCESS";
export const OPERATOR_MODEL_ERROR = "OPERATOR_MODEL_ERROR";
export const GET_CONTACT_HISTORY_DETAIL_SUCCESS =
  "GET_CONTACT_HISTORY_DETAIL_SUCCESS";
export const GET_CONTACT_HISTORY_DETAIL_ERROR =
  "GET_CONTACT_HISTORY_DETAIL_ERROR";
export const GET_CONTACT_HISTORY_DETAIL_START =
  "GET_CONTACT_HISTORY_DETAIL_START";

export const GET_PANALTY_PAYMENT_DETAIL_SUCCESS =
  "GET_PANALTY_PAYMENT_DETAIL_SUCCESS";
export const GET_PANALTY_PAYMENT_DETAIL_ERROR =
  "GET_PANALTY_PAYMENT_DETAIL_ERROR";
export const GET_PANALTY_PAYMENT_DETAIL_START =
  "GET_PANALTY_PAYMENT_DETAIL_START";

//Operator Substitue
export const GET_SUBSTITUE_BIKES_START = "GET_SUBSTITUE_BIKES_START";
export const GET_SUBSTITUE_BIKES_SUCCESS = "GET_SUBSTITUE_BIKES_SUCCESS";
export const GET_SUBSTITUE_BIKES_ERROR = "GET_SUBSTITUE_BIKES_ERROR";

//Operator Transaction Details
export const GET_TRANSACTION_DETAILS_START = "GET_TRANSACTION_DETAILS_START";
export const GET_TRANSACTION_DETAILS_SUCCESS =
  "GET_TRANSACTION_DETAILS_SUCCESS";
export const GET_TRANSACTION_DETAILS_ERROR = "GET_TRANSACTION_DETAILS_ERROR";

// Admin Fleet List
export const ALL_MOTORCYCLE_LIST_FILTER_SUCCESS =
  "ALL_MOTORCYCLE_LIST_FILTER_SUCCESS";
export const CA_MOTORCYCLE_LIST_FILTER_SUCCESS =
  "CA_MOTORCYCLE_LIST_FILTER_SUCCESS";
export const REB_MOTORCYCLE_LIST_FILTER_SUCCESS =
  "REB_MOTORCYCLE_LIST_FILTER_SUCCESS";
export const EB_MOTORCYCLE_LIST_FILTER_SUCCESS =
  "EB_MOTORCYCLE_LIST_FILTER_SUCCESS";
export const UM_MOTORCYCLE_LIST_FILTER_SUCCESS =
  "UM_MOTORCYCLE_LIST_FILTER_SUCCESS";
export const UV_MOTORCYCLE_LIST_FILTER_SUCCESS =
  "UV_MOTORCYCLE_LIST_FILTER_SUCCESS";

export const GET_MANAGE_USER_DATA_START = "GET_MANAGE_USER_DATA_START";
export const GET_MANAGE_USER_DATA_SUCCESS = "GET_MANAGE_USER_DATA_SUCCESS";
export const GET_MANAGE_USER_DATA_ERROR = "GET_MANAGE_USER_DATA_ERROR";

export const CANCEL_PAYMENTS_LIST_START = "CANCEL_PAYMENTS_LIST_START";
export const CANCEL_PAYMENTS_LIST_SUCCESS = "CANCEL_PAYMENTS_LIST_SUCCESS";
export const CANCEL_PAYMENTS_LIST_ERROR = "CANCEL_PAYMENTS_LIST_ERROR";

export const PENDING_PAYMENTS_DETAILS_START = "PENDING_PAYMENTS_DETAILS_START";
export const PENDING_PAYMENTS_DETAILS_SUCCESS =
  "PENDING_PAYMENTS_DETAILS_SUCCESS";
export const PENDING_PAYMENTS_DETAILS_ERROR = "PENDING_PAYMENTS_DETAILS_ERROR";

export const COMPLETED_PAYMENTS_DETAILS_START =
  "COMPLETED_PAYMENTS_DETAILS_START";
export const COMPLETED_PAYMENTS_DETAILS_SUCCESS =
  "COMPLETED_PAYMENTS_DETAILS_SUCCESS";
export const COMPLETED_PAYMENTS_DETAILS_ERROR =
  "COMPLETED_PAYMENTS_DETAILS_ERROR";

export const CANCEL_CHARGE_PAYMENTS_DETAILS_START =
  "CANCEL_CHARGE_PAYMENTS_DETAILS_START";
export const CANCEL_CHARGE_PAYMENTS_DETAILS_SUCCESS =
  "CANCEL_CHARGE_PAYMENTS_DETAILS_SUCCESS";
export const CANCEL_CHARGE_PAYMENTS_DETAILS_ERROR =
  "CANCEL_CHARGE_PAYMENTS_DETAILS_ERROR";

export const PENALTY_PAYMENTS_DETAILS_START = "PENALTY_PAYMENTS_DETAILS_START";
export const PENALTY_PAYMENTS_DETAILS_SUCCESS =
  "PENALTY_PAYMENTS_DETAILS_SUCCESS";
export const PENALTY_PAYMENTS_DETAILS_ERROR = "PENALTY_PAYMENTS_DETAILS_ERROR";

export const RESENT_PAYMENT_START = "RESENT_PAYMENT_START";
export const RESENT_PAYMENT_SUCCESS = "RESENT_PAYMENT_SUCCESS";
export const RESENT_PAYMENT_ERROR = "RESENT_PAYMENT_ERROR";

// header notification

export const NOTIFICATION_START = "NOTIFICATION_START";
export const NOTIFICATION_SUCCESS = "NOTIFICATION_SUCCESS";
export const NOTIFICATION_ERROR = "NOTIFICATION_ERROR";

//Verify User Mobile number and email
export const OPERATOR_VERIFICATION_SUCCESS = "OPERATOR_VERIFICATION_SUCCESS";
export const OPERATOR_VERIFICATION_ERROR = "OPERATOR_VERIFICATION_ERROR";
export const OPERATOR_VERIFICATION_START = "OPERATOR_VERIFICATION_START";

export const MOTORCYCLE_MODEL_SUCCESS = "MOTORCYCLE_MODEL_SUCCESS";
export const MOTORCYCLE_MODEL_ERROR = "MOTORCYCLE_MODEL_ERROR";
export const MOTORCYCLE_MODEL_START = "MOTORCYCLE_MODEL_START";

export const ALL_RIDER_FILTER_SUCCESS = "ALL_RIDER_FILTER_SUCCESS";
export const ALL_RIDER_FILTER_DOWNLOAD_SUCCESS = "ALL_RIDER_FILTER_DOWNLOAD_SUCCESS"
export const CURRENTLY_RIDER_FILTER_SUCCESS = "CURRENTLY_RIDER_FILTER_SUCCESS";
export const REBOOKING_RIDER_FILTER_SUCCESS = "REBOOKING_RIDER_FILTER_SUCCESS";
export const EXTERNAL_RIDER_FILTER_SUCCESS = "EXTERNAL_RIDER_FILTER_SUCCESS";
export const MAINTANCE_RIDER_FILTER_SUCCESS = "MAINTANCE_RIDER_FILTER_SUCCESS";
export const UNDER_VERIFICATION_RIDER_FILTER_SUCCESS =
  "UNDER_VERIFICATION_RIDER_FILTER_SUCCESS";
  

export const CLEAR_ALL_DATA = "CLEAR_ALL_DATA";

export const ONBOARDING_FORM_DATA_FIELD = "ONBOARDING_FORM_DATA_FIELD";
export const BANK_TAX_ACCOUNT_DETAIL = "BANK_TAX_ACCOUNT_DETAIL";
export const ONBOARDING_BUSISINESS_DETAIL_DATA =
  "ONBOARDING_BUSISINESS_DETAIL_DATA";
export const ONBOARDING_CANCEL_POLICY = "ONBOARDING_CANCEL_POLICY";
export const CLEAR_CHASSIS_NO_DATA = "CLEAR_CHASSIS_NO_DATA";
export const CHECK_VALIDATE_DATA_ACCOUNTDETAIL =
  "CHECK_VALIDATE_DATA_ACCOUNTDETAIL";
export const CHECK_VALIDATE_DATA_BUSSINACEDETAIL =
  "CHECK_VALIDATE_DATA_BUSSINACEDETAIL";
export const CHECK_VALIDATE_DATA_BANKTAXDETAIL =
  "CHECK_VALIDATE_DATA_BANKTAXDETAIL";
export const CHECK_VALIDATE_DATA_CANCELPOLICYDATA =
  "CHECK_VALIDATE_DATA_CANCELPOLICYDATA";

export const ADDING_CUSTOMER_RATING = "ADDING_CUSTOMER_RATING";
export const ADDING_CUSTOMER_RATING_SUCCESS = "ADDING_CUSTOMER_RATING_SUCCESS";
export const ADDING_CUSTOMER_RATING_FAILED = "ADDING_CUSTOMER_RATING_FAILED";

export const COUNTRY_VALUE = "COUNTRY_VALUE";
export const COUNTRY_VALUE_SUCCESS = "COUNTRY_VALUE_SUCCESS";
export const COUNTRY_VALUE_ERROR = "COUNTRY_VALUE_ERROR";

export const GOOGLE_LOCATION_START = "GOOGLE_LOCATION_START";
export const GOOGLE_LOCATION_SUCCESS = "GOOGLE_LOCATION_SUCCESS";
export const GOOGLE_LOCATION_ERROR = "GOOGLE_LOCATION_ERROR";
export const CLEAR_OPERATOR_PREVIOUS_REDUCER =
  "CLEAR_OPERATOR_PREVIOUS_REDUCER";

export const CLEAR_PREVIOUS_REDUCER = "CLEAR_PREVIOUS_REDUCER";

export const CLEAR_FIRST_TIME_PREVIOUS_REDUCER =
  "CLEAR_FIRST_TIME_PREVIOUS_REDUCER";
